$popover-menu-min-height: 45px;

$button-min-height: 22px;
$button-min-width: 100px;
$button-padding: 10px;
$button-border-radius: 4px;
$button-gap: 15px;

.presence {
  &__popover-menu-item {
    width: 100% !important;
    min-height: $popover-menu-min-height !important;
    padding: 0 !important;
  }

  &__button {
    height: $button-min-height;
    min-width: $button-min-width;
    align-items: center;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-left: $button-padding;
    padding-right: $button-padding;
    border: none;
    border-radius: $button-border-radius;
    gap: $button-gap;
    cursor: pointer;

    :global .text {
      text-align: left;
    }

    &:hover {
      filter: brightness(95%);
    }

    &:focus-visible {
      filter: brightness(95%);
    }
  }
}
